import Player from "@vimeo/player";
import CookieConsentManager from "../../../../src/scripts/helpers/cookie-consent-manager";

export default class VimeoPlayer {
	static init() {
		const isNeosBackend = document.body.classList.contains('neos-backend');
		if (isNeosBackend) {
			return;
		}

        let elements = document.querySelectorAll('.vimeo-player');
        if(!elements.length) {
            return;
        }

        Array.from(elements).forEach(el => {
			new VimeoPlayer(el)
		});
	}

	static classes = {
        node: 'vimeo-player',
		get overlay() {
			return this.node + '__overlay'
		},
		get poster() {
			return this.node + '__poster'
		},
		get iframe() {
			return this.node + '__iframe'
		},
		get inner() {
			return this.node + '__inner'
		},
		state: {
			get initialised() {
				return VimeoPlayer.classes.node + '--is-initialized'
			},
			get unstarted() {
				return VimeoPlayer.classes.node + '--is-unstarted'
			},
			get ended() {
				return VimeoPlayer.classes.node + '--is-ended'
			},
			get playing() {
				return VimeoPlayer.classes.node + '--is-playing'
			},
			get paused() {
				return VimeoPlayer.classes.node + '--is-paused'
			},
			get buffering() {
				return VimeoPlayer.classes.node + '--is-buffering'
			},
			get cued() {
				return VimeoPlayer.classes.node + '--is-cued'
			}
		}
	}

	constructor(element) {
		this.options = '';
		this.element = element;
		this.iframe = element.querySelector('.' + VimeoPlayer.classes.iframe);
		this.overlay = element.querySelector('.' + VimeoPlayer.classes.overlay);
		this.poster = element.querySelector('.' + VimeoPlayer.classes.poster);
		this.inner = element.querySelector('.' + VimeoPlayer.classes.inner);
		this.state = 'unstarted';
		this.isInitialised = false;
		this.player = {};
		this.options = {
			id: this.element.dataset.id,
            isShowcase: this.element.dataset.isShowcase === "true"
		};

        if(!CookieConsentManager.hasConsent('vimeo')) {
            this.element.querySelector('.cookie-consent').classList.remove('is-hidden');
            this.element.querySelector('.vimeo-player__button--play').setAttribute('aria-hidden', 'true');
        }
        CookieConsentManager.onHasConsent('vimeo', () => {
            this.element.querySelector('.cookie-consent').remove();
            this.setFallbackPoster();
            this.element.querySelector('.vimeo-player__button--play').setAttribute('aria-hidden', 'false');
        });

		this.overlay.addEventListener('click', () => {
            CookieConsentManager.onHasConsent('vimeo', () => {
                if (!this.isInitialised) {
                    this.createIframe();
                    this.player = new Player(this.iframe);
                    this.player.ready().then(() => {
                        this.setState('initialised');
                        let iframe = this.inner.querySelector('iframe');
                        iframe.classList.add(VimeoPlayer.classes.iframe);
                    });

                    this.player.on('play', () => {
                        this.setState('playing')
                    });

                    this.player.on('pause', () => {
                        this.setState('paused')
                    });

                    this.player.on('ended', () => {
                        this.setState('ended')
                    });
                }

                this.player.play().then(() => {
                    this.setState('playing')
                });

                this.inner.querySelector('iframe').focus();
            });
		});
	}

	setState(state) {
		let stateClass = VimeoPlayer.classes.state[state];
		if (this.element.classList.contains(stateClass)) return;

		for (let key in VimeoPlayer.classes.state) {
			if (key !== 'initialised') {
				this.element.classList.remove(VimeoPlayer.classes.state[key]);
			}
		}
		this.state = state;
		this.element.classList.add(stateClass);
	}

    setFallbackPoster() {
        let posterImg = this.poster.querySelector('img');
        if(posterImg.getAttribute('src')) {
            return;
        }
        let url = `https://vimeo.com/api/oembed.json?url=http%3A//vimeo.com/${this.options.isShowcase ? 'album/' : ''}` + this.element.dataset.id;
        fetch(url)
            .then(response => response.json())
            .then(data => {
                if (!posterImg.getAttribute('src') && data.thumbnail_url) {
                    posterImg.setAttribute('src', data.thumbnail_url);
                    posterImg.classList.remove('is-hidden');
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    createIframe() {
        if (this.iframe) {
            return;
        }
        let iframe = document.createElement('IFRAME');
        iframe.setAttribute('allow', 'autoplay');
        iframe.src = this.options.isShowcase ? `https://vimeo.com/showcase/${this.options.id}/embed` : `https://player.vimeo.com/video/${this.options.id}`;
        iframe.classList.add(VimeoPlayer.classes.iframe);
        this.inner.prepend(iframe);
        this.iframe = iframe;
    }
}
